<div class="fx-column">

  <div class="fx-row align-items-center justify-content-between">
    <div class="fx-row align-items-center justify-content-start">
      <mat-icon class="main mr-10 type-icon" fontSet="material-icons-outlined">language</mat-icon>
      <div class="fx-column">
        <span class="page-title">{{'INTEGRATIONS.WEBSITE.TITLE' | translate}}</span>
        <span class="page-subtitle">{{'INTEGRATIONS.WEBSITE.DESCRIPTION' | translate}}</span>
      </div>
    </div>
    <button class="main-button" (click)="addIntegrationDialog()">
      <div class="fx-row align-items-center justify-content-start">
        <mat-icon class="white mr-5" fontSet="material-icons-outlined">power</mat-icon>
        {{'INTEGRATIONS.CREATE_TITLE' | translate}}
      </div>
    </button>
  </div>

  <mat-divider class="mv-20"></mat-divider>

  @if (!loading && done && !noDocs) {
  <mat-card class="p-0">
    <app-crawler-filters-drawer [count]="crawlers.totalDocs" [loading]="loading" [autoRefresh]="autoRefresh"
      (filtersChange)="onFiltersChange($event)" (refresh)="refreshCrawlers()">

      <table mat-table [dataSource]="crawlers.docs" style="z-index: 0;" matSort (matSortChange)="onSortChange($event)">

        <!-- Name -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="integration.name">
            <span class="small light bold">{{'INTEGRATIONS.WEBSITE.NAME' | translate}}</span>
          </th>
          <td mat-cell *matCellDef="let row">
            @if (canTriggerIntegrationOrIsSuperAdmin(row)) {
              <span class="text bold">
                <a routerLink="{{ row.integration._id }}">{{ row.integration.name }}</a>
              </span>
            } @else {
              <span class="text bold">{{ row.integration.name }}</span>
            }
          </td>
        </ng-container>

        <!-- Type (chip color + URL menu for types that have a URL) -->
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>
            <span class="small light bold">{{'INTEGRATIONS.TYPE' | translate}}</span>
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="fx-row align-items-center justify-content-start">
              @if (hasSpecUrl(row.crawler)) {
              <div class="chip clickable" [class.main]="row.crawler.type === CrawlerType.SINGLE_URL"
                [class.green]="row.crawler.type === CrawlerType.DISCOVERY" [cdkMenuTriggerFor]="urlMenu">
                {{ 'INTEGRATIONS.TYPE_' + row.crawler.type | translate }}
              </div>
              <ng-template #urlMenu>
                <mat-card class="menu-container p-8 elevation" style="max-width: 100% !important;" cdkMenu>
                  <a [href]="getSpecUrl(row.crawler)" target="_blank">{{ (getSpecUrl(row.crawler) ?? '') | shortUrl
                    }}</a>
                </mat-card>
              </ng-template>
              } @else {
              <div class="chip blue">
                {{ 'INTEGRATIONS.TYPE_' + row.crawler.type | translate }}
              </div>
              }
            </div>
          </td>
        </ng-container>

        <!-- Status (same for all types) -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="crawler.progress.status">
            <span class="small light bold">{{ 'INTEGRATIONS.STATUS' | translate }}</span>
          </th>
          <td mat-cell *matCellDef="let row">
            <app-crawl-status [status]="row.crawler.progress?.status"></app-crawl-status>
          </td>
        </ng-container>

        <!-- Progress (per-type rendering) -->
        <ng-container matColumnDef="progress">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="crawler.progress.processed">
            <span class="small light bold">{{ 'INTEGRATIONS.PROGRESS' | translate }}</span>
          </th>
          <td mat-cell *matCellDef="let row">
            @switch (row.crawler.type) {
            @case (CrawlerType.SINGLE_URL) {
            @if (row.crawler.progress && row.crawler.progress.total > 0) {
            <div class="progress-container">
              <div class="small">
                <span class="small">
                  {{ row.crawler.progress.processed || 0 }} / {{ row.crawler.progress.total || 0 }}
                  <span class="light">({{ getProgressPercentage(row.crawler) }}%)</span>
                </span>
              </div>
              <mat-progress-bar mode="determinate" [value]="getProgressPercentage(row.crawler)"
                [color]="row.crawler.progress.status === 'FAILED' ? 'warn' : 'primary'">
              </mat-progress-bar>
              @if (row.crawler.progress.failed > 0) {
              <div class="progress-details light small mt-4">
                <mat-icon fontSet="material-icons-outlined" inset inline class="mr-5">error_outline</mat-icon>
                <span>{{ row.crawler.progress.failed }} {{ 'INTEGRATIONS.FAILED' | translate }}</span>
              </div>
              }
            </div>
            } @else {
            <span class="light">-</span>
            }
            }
            @case (CrawlerType.EXCEL_BATCH) {
            @if (row.crawler.progress && row.crawler.progress.total > 0) {
            <div class="progress-container">
              <div class="small">
                <span class="small">
                  {{ row.crawler.progress.processed || 0 }} / {{ row.crawler.progress.total || 0 }}
                  <span class="light">({{ getProgressPercentage(row.crawler) }}%)</span>
                </span>
              </div>
              <mat-progress-bar mode="determinate" [value]="getProgressPercentage(row.crawler)"
                [color]="row.crawler.progress.status === 'FAILED' ? 'warn' : 'primary'">
              </mat-progress-bar>
              @if (row.crawler.progress.failed > 0) {
              <div class="progress-details light small mt-4">
                <mat-icon fontSet="material-icons-outlined" inset inline class="mr-5">error_outline</mat-icon>
                <span>{{ row.crawler.progress.failed }} {{ 'INTEGRATIONS.FAILED' | translate }}</span>
              </div>
              }
            </div>
            } @else {
            <span class="light">-</span>
            }
            }
            @case (CrawlerType.DISCOVERY) {
            @if (row.crawler.progress?.status === 'DISCOVERING' && row.crawler.spec.pendingJobs) {
            <span class="small light">{{ row.crawler.spec.pendingJobs }} {{ 'INTEGRATIONS.PENDING_JOBS' | translate
              }}</span>
            } @else if (row.crawler.progress && row.crawler.progress.total > 0) {
            <div class="progress-container">
              <div class="small">
                <span class="small">
                  {{ row.crawler.progress.processed || 0 }} / {{ row.crawler.progress.total || 0 }}
                  <span class="light">({{ getProgressPercentage(row.crawler) }}%)</span>
                </span>
              </div>
              <mat-progress-bar mode="determinate" [value]="getProgressPercentage(row.crawler)"
                [color]="row.crawler.progress.status === 'FAILED' ? 'warn' : 'primary'">
              </mat-progress-bar>
            </div>
            } @else {
            <span class="light">-</span>
            }
            }
            }
          </td>
        </ng-container>

        <!-- Recurrence -->
        <ng-container matColumnDef="recurrence">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="integration.createdAt">
            <span class="small light bold">{{'INTEGRATIONS.WEBSITE.RECURRENCE' | translate}}</span>
          </th>
          <td mat-cell *matCellDef="let row">
            @if (row.crawler.recurrence !== 'once') {
            <div class="fx-column">
              <span class="text">{{'DATES.'+row.crawler.recurrence.toUpperCase()+'LY' | translate}}</span>
              <span class="small light" [matTooltipClass]="{'uzai-tooltip':true}"
                [matTooltip]="'INTEGRATIONS.NEXT_TRIGGER' | translate">{{nextTrigger(row.crawler)}}</span>
            </div>
            } @else {
            <div class="fx-column">
              <span class="text">{{'DATES.ONCE' | translate}}</span>
              @if (row.integration.createdAt) {
              <span class="small light" [matTooltipClass]="{'uzai-tooltip':true}"
                [matTooltip]="'INTEGRATIONS.ONCE_TRIGGER' | translate">{{onceTrigger(row)}}</span>
              }
            </div>
            }
          </td>
        </ng-container>

        <!-- Trademark -->
        <ng-container matColumnDef="trademark">
          <th mat-header-cell *matHeaderCellDef>
            <span class="small light bold">{{'INTEGRATIONS.WEBSITE.LINKED_TRADEMARKS' | translate}}</span>
          </th>
          <td mat-cell *matCellDef="let row">
            @if (row.crawler.trademarks && row.crawler.trademarks.length === 1) {
            <div class="fx-column">
              <span class="text">{{row.crawler.trademarks[0].name || row.crawler.trademarks[0].identifierNumber}}</span>
            </div>
            } @else if (row.crawler.trademarks && row.crawler.trademarks.length > 1) {
            <div class="fx-row align-items-center justify-content-start">
              <span class="text">{{row.crawler.trademarks[0].name ||
                row.crawler.trademarks[0].identifierNumber}}</span>&nbsp;<span class="text">{{'UTILS.AND_X_MORE' |
                translate:{x:row.crawler.trademarks.length-1} }}</span>
            </div>
            } @else {
            <span class="light">-</span>
            }
          </td>
        </ng-container>

        <!-- Countries (selected codes; only DISCOVERY generic uses them) -->
        <ng-container matColumnDef="countries">
          <th mat-header-cell *matHeaderCellDef>
            <span class="small light bold">{{'INTEGRATIONS.WEBSITE.LINKED_COUNTRIES' | translate}}</span>
          </th>
          <td mat-cell *matCellDef="let row">
            @if (row.crawler.countryCodes && row.crawler.countryCodes.length > 0) {
            <app-document-countries [territories]="row.crawler.countryCodes"></app-document-countries>
            } @else {
            <span class="light">-</span>
            }
          </td>
        </ng-container>

        <!-- Owner -->
        <ng-container matColumnDef="owner">
          <th mat-header-cell *matHeaderCellDef>
            <span class="small light bold">{{'INTEGRATIONS.WEBSITE.OWNER' | translate}}</span>
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="fx-row justify-content-start align-items-center">
              <app-avatar [user]="row.integration.owner" [size]="25"></app-avatar>
              <div class="fx-column align-items-start justify-content-start ml-5">
                <span class="small">{{row.integration.owner.firstName}} {{row.integration.owner.lastName}}</span>
              </div>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      @if (done && !loading && crawlers.totalDocs === 0) {
      <div class="p-16">
        <span class="text light">{{'INTEGRATIONS.SEARCH_NO_INTEGRATION' | translate}}</span>
      </div>
      }

      <mat-paginator [length]="crawlers.totalDocs || 0" [pageSize]="crawlers.limit || 0"
        [pageIndex]="crawlers && crawlers.page ? (crawlers.page-1) : 0" [pageSizeOptions]="[10, 25, 50, 100]"
        (page)="handlePage($event)">
      </mat-paginator>
    </app-crawler-filters-drawer>
  </mat-card>
  }

  @if (!loading && done && noDocs) {
  <app-empty-placeholder class="fx-flex" [offset]="125" [title]="'INTEGRATIONS.NO_INTEGRATION'"
    [message]="'INTEGRATIONS.LIST.SUBTITLE'" [button]="noIntegrationButton"></app-empty-placeholder>
  }
</div>
